import React, { useState } from "react";
import { Carousel } from "react-bootstrap";
import { AddToCartButton } from "../../../../../Components/AddToCartComponent";
import { StyledImageProduct, StyledTwoColumn } from "../../../style.css";
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
import { AlertComponent } from "../../../../../Components/AlertComponent";
import { formatCurrency } from "../../../../../Helpers/currency";

function SimpleProductLayout({ product }) {
  const { t } = useTranslation();
  const [error, setError] = useState(null);

  return (
    <StyledTwoColumn>
      <div>
        <Carousel data-bs-theme="dark" indicators={product.images.length > 1}>
          {product.images.map((i) => (
            <Carousel.Item key={i.src}>
              <StyledImageProduct src={i.src} className="w-100 d-block" />
            </Carousel.Item>
          ))}
        </Carousel>
      </div>

      <div className="d-flex flex-column">
        <h1 className="h3 fw-bold mb-2">{t(product.name)}</h1>
        <p className="h5 mb-3" style={{ color: "var(--tws-brown)" }}>
          {formatCurrency(product.price)}
        </p>
        {product.short_description && (
          <div className="mb-4" id="product-desc">
            {parse(t(product.short_description))}
          </div>
        )}

        <AddToCartButton
          originalProduct={product}
          product={product}
          setError={setError}
          validator={() => ({ success: true })}
        />
      </div>

      {error && (
        <AlertComponent variant="danger">{error}</AlertComponent>
      )}
    </StyledTwoColumn>
  );
}

export default SimpleProductLayout;
